export const pageToModuleMap = {
    "dashboard": null, // Dashboard is always visible
    "employees": "employees",
    "attendance": "attendance",
    "reports": "reports",
    "calendar": "calendar",
    "messages": "messages",
    "Mo3tiAdminDocumentRequests": "documents",
    "LeaveApprovalPage": "leaves",
    "Mo3tiAdvancementManagement": "advancements",
    "ChangesPage": "changesPage", // Employee changes uses separate changesPage module
    "Payroll": "payroll",
    "TaxCalculator": "payroll", // Tax calculator is part of payroll
    "companyConfig": "configurations", // Company Configuration - accessible by admin levels
    "Settings": null,
};

// Pages that should only appear in Admin View (not in Manager View)
export const adminOnlyPages = ["Payroll", "companyConfig"];